import {Box, useTheme} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery/useMediaQuery";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import NavigationPanel from "../OrganizationSettings/Utilities/NavigationPanel";
import styles from "../OrganizationSettings/organizationMainStyles";
import {fragmentId} from "../OrganizationSettings/Utilities/organizationSettingsConstants";
import DefaultSuggestedResponses from "./DefaultSuggestedResponses";

// Settings that apply to all organizations, so there's no organization to select
const navigationItems = [
    {
        name: 'Generated Replies',
        icon: AutoAwesomeIcon,
        permission: true,
        fragmentId: fragmentId.SUGGESTED_RESPONSES,
    },
];

export default function GlobalSettingsEntry() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box sx={styles.root}>
            <Box sx={styles.container}>
                <Box sx={style.headerWrapper}>
                    <Box component="h1" sx={style.title}>Global Configuration</Box>
                    <Box component="p" sx={style.subtitle}>Settings that apply to all organizations</Box>
                </Box>
                <Box sx={{...style.bodyWrapper, ...(isMobile ? style.flexColumn : style.flexRow)}}>
                    <NavigationPanel
                        items={navigationItems}
                        selectedFragmentId={fragmentId.SUGGESTED_RESPONSES}
                        setLocation={() => {}}
                    />
                    <DefaultSuggestedResponses/>
                </Box>
            </Box>
        </Box>
    );
}

const style = {
    // Takes the place of the organization search and selection in Organizations Configuration
    headerWrapper: {
        mb: '25px',
    },
    title: {
        m: 0,
        fontFamily: 'LarsseitMedium',
        fontSize: {xs: '20px', md: '24px'},
        lineHeight: 1.2,
    },
    subtitle: {
        m: 0,
        mt: '6px',
        fontSize: {xs: '15px', md: '16px'},
        color: '#495D5E',
    },
    bodyWrapper: {
        display: 'flex',
        gap: 4,
        alignItems: 'flex-start',
    },
    flexColumn: {
        flexDirection: 'column'
    },
    flexRow: {
        flexDirection: 'row'
    },
};
